var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.5 23C11.0475 23 9.6825 22.7242 8.405 22.1726C7.1275 21.621 6.01625 20.8731 5.07125 19.9287C4.12625 18.9837 3.3783 17.8725 2.8274 16.595C2.2765 15.3175 2.0007 13.9525 2 12.5C2 11.0475 2.2758 9.6825 2.8274 8.405C3.379 7.1275 4.12695 6.01625 5.07125 5.07125C6.01625 4.12625 7.1275 3.3783 8.405 2.8274C9.6825 2.2765 11.0475 2.0007 12.5 2C13.9525 2 15.3175 2.2758 16.595 2.8274C17.8725 3.379 18.9837 4.12695 19.9287 5.07125C20.8738 6.01625 21.622 7.1275 22.1736 8.405C22.7252 9.6825 23.0007 11.0475 23 12.5C23 13.9525 22.7242 15.3175 22.1726 16.595C21.621 17.8725 20.8731 18.9837 19.9287 19.9287C18.9837 20.8738 17.8725 21.622 16.595 22.1736C15.3175 22.7252 13.9525 23.0007 12.5 23ZM12.5 20.9C13.445 20.9 14.355 20.7467 15.23 20.4401C16.105 20.1335 16.91 19.6918 17.645 19.115L5.885 7.355C5.3075 8.09 4.86545 8.895 4.55885 9.77C4.25225 10.645 4.0993 11.555 4.1 12.5C4.1 14.845 4.91375 16.8312 6.54125 18.4587C8.16875 20.0862 10.155 20.9 12.5 20.9ZM19.115 17.645C19.6925 16.91 20.1345 16.105 20.4411 15.23C20.7477 14.355 20.9007 13.445 20.9 12.5C20.9 10.155 20.0862 8.16875 18.4587 6.54125C16.8312 4.91375 14.845 4.1 12.5 4.1C11.555 4.1 10.645 4.25295 9.77 4.55885C8.895 4.86475 8.09 5.3068 7.355 5.885L19.115 17.645Z",
    fill: "#0071BC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlocked);
export default __webpack_public_path__ + "static/media/blocked.85e110fa244bf647b1db6b5750eb1ac9.svg";
export { ForwardRef as ReactComponent };